import { useEffect, useRef, useState } from 'react';

const VIDEO_SRC = '/kiosk-purchase-success.mp4';

const KioskPurchaseSuccessVideo = ({ onEnded }) => {
  const videoRef = useRef(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const node = videoRef.current;
    if (!node) return;
    node.muted = false;
    const playPromise = node.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Browser blocked unmuted autoplay — retry muted so the video still plays.
        node.muted = true;
        node.play().catch(() => setHasError(true));
      });
    }
  }, []);

  if (hasError) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <video
        ref={videoRef}
        src={VIDEO_SRC}
        autoPlay
        playsInline
        onEnded={onEnded}
        onError={() => setHasError(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </div>
  );
};

export default KioskPurchaseSuccessVideo;
